module.exports = __webpack_public_path__ + "static/media/orange-dropdown.46aeb124.svg";